const XAVIER_URL = process.env.REACT_APP_XAVIER_URL
const RAVEN_URL = process.env.REACT_APP_RAVEN_URL
const TRUBEL_URL = process.env.REACT_APP_TRUBEL_URL
const TYRION_URL = process.env.REACT_APP_TYRION_URL

const INTERNAL_ASSET_API = 'https://internal-asset.cadjin.com'
const TEMPLATE_URL = XAVIER_URL + '/api/v1/template'
const WATCHLIST_URL = XAVIER_URL + '/api/v1/watchlist'
const WISHLIST_URL = XAVIER_URL + '/api/v1/ecommerce/wishlist'
const FAVOURITE_URL = XAVIER_URL + '/api/v1/like/content'
const CONTENT_FILTERING = XAVIER_URL + '/api/v2/content/filter'
const CONTENT_SEARCH = XAVIER_URL + '/api/v1/content/new-search'
const RELATED_CONTENT = XAVIER_URL + '/api/v1/content/related/'
const DETAIL_CONTENT = XAVIER_URL + '/api/v1/content/detail/'
const CONTENT_WATCH_URL = XAVIER_URL + '/api/v1/content/video_url/'
const AUDIO_WATCH_URL = XAVIER_URL + '/api/v1/content/audio_url/'
const PARENT_DETAIL_CONTENT = XAVIER_URL + '/api/v1/content/parent-detail/'
const GET_CATEGORY = XAVIER_URL + '/api/v1/content/meta-data/system'
const SYSTEM_METADATA = XAVIER_URL + '/api/v1/metadata/system'
const ARTIST_LISTING = XAVIER_URL + '/api/v1/artist'
const VENUE_LISTING = XAVIER_URL + '/api/v1/venue'
const AD_CAMPAIGN = XAVIER_URL + '/api/v1/ad-campaign/'
// const ANALYTICS_API = XAVIER_URL + '/api/v1/analytics/event'
const GET_REVIEWS_API = XAVIER_URL + '/api/v1/review'
const GET_COMMENTS_API = XAVIER_URL + '/api/v1/comments'
const POST_LIKE_URL = XAVIER_URL + '/api/v1/like'
const IPTV_CHANNEL_FILTER = XAVIER_URL + '/api/v2/content/iptv-channel-filter'
const IPTV_CHANNEL_SCHEDULE = XAVIER_URL + '/api/v1/content/iptv-channel/schedule'
const IPTV_CHANNEL_PLAYLIST = XAVIER_URL + '/api/v1/content/iptv-channel/playlist'
const IPTV_CHANNEL_CONTENT_URL = XAVIER_URL + '/api/v1/content/iptv-channel/content-url'
const IPTV_CHANNEL_EPG_SCHEDULE = XAVIER_URL + '/api/v1/content/iptv-channel/epg-schedule'
const RELATED_CHANNEL = XAVIER_URL + '/api/v1/content/related-channel/'
const CUSTOM_FORM = XAVIER_URL + '/api/v1/custom-forms'
const PLAYER_SESSION = XAVIER_URL + '/api/v1/analytics/player-session'
const TEMPLATE_V2_URL = XAVIER_URL + '/api/v1/template/website'
const LIVE_COMMENTS_API = XAVIER_URL + '/api/v1/comments/content'
const ECOMMERCE_API = XAVIER_URL + '/api/v1/ecommerce'
const PRODUCT_FILTER_API = XAVIER_URL + '/api/v1/ecommerce/product/filter'
const PRODUCT_FILTER_API_V2 = XAVIER_URL + '/api/v2/ecommerce/product/filter'
const OVERRIDE_FEED_API = XAVIER_URL + '/api/v2/content/iptv-channel/override-feed'
const LIVE_ADHOC_AD_API = XAVIER_URL + '/api/v2/ad-campaign/live-adhoc-ad'

const ACCOUNT_API = RAVEN_URL + '/api/v1/account/detail'
const LOGIN_API = RAVEN_URL + '/api/v1/user/login'
const SOCIAL_LOGIN_API = RAVEN_URL + '/api/v1/user/social-login'
const SIGNUP_API = RAVEN_URL + '/api/v1/user/subscriber/signup'
const LOGOUT_API = RAVEN_URL + '/api/v1/user/logout'
const FORGOT_PASSWORD = RAVEN_URL + '/api/v1/user/forgot-password'
const VALIDATE_SESSION = RAVEN_URL + '/api/v1/user/validate-session'
const SEND_VERIFY_EMAIL_OTP = RAVEN_URL + '/api/v1/user/send-verify-email-otp'
const CHANGE_PASSWORD = RAVEN_URL + '/api/v1/user/change-password'
const SEND_VERIFY_EMAIL = RAVEN_URL + '/api/v1/user/send-verify-email'
const VERIFY_EMAIL_OTP = RAVEN_URL + '/api/v1/user/verify-email-otp'
const VERIFY_EMAIL = RAVEN_URL + '/api/v1/user/verify-email'
const UPDATE_USER_INFO = RAVEN_URL + '/api/v1/user/update-info'
const STATIC_PAGE = RAVEN_URL + '/api/v1/config/static-pages'
const RESET_PASSWORD_KEY_VALIDATION = RAVEN_URL + '/api/v1/user/check-reset-password-key'
const RESET_PASSWORD = RAVEN_URL + '/api/v1/user/reset-password'
// const TEMPLATE_V2_URL = RAVEN_URL + '/api/v2/template'
const CUSTOM_PAGES_API = XAVIER_URL + '/api/v1/template/custom-page'
const POLL_API = RAVEN_URL + '/api/v1/poll'

const GET_ACTIVE_SUBSCRIPTIONS = TYRION_URL + '/api/v1/payment/active-subscription'
const GET_MY_PURCHASED_PLANS = TYRION_URL + '/api/v1/payment/my-purchased-plans'

const GET_MY_ACCESSIBLE_PLANS = TYRION_URL + '/api/v1/payment/my-accessed-plans'
const GET_SUBSCRIPTIONS = TYRION_URL + '/api/v1/subscription'

const PAYEMENT_ORGS = TYRION_URL + '/api/v1/payment-gateway/customer-org'
const GET_DISCOUNTS = TYRION_URL + '/api/v1/payment/discount'
const GET_ESTIMATE = TYRION_URL + '/api/v1/payment/get-estimation'
const CREATE_TRANSACTION = TYRION_URL + '/api/v1/payment/create-transaction'
const CAPTURE_PAYMENT = TYRION_URL + '/api/v1/payment/capture-payment'
const GET_TRANSACTION = TYRION_URL + '/api/v1/payment/get-transactions'
const GET_USER_TRANSACTION = TYRION_URL + '/api/v1/payment/transactions'
const GET_RENEWAL_SUBSCRIPTION = TYRION_URL + '/api/v1/payment/renewal-subscriptions'
const ECOMMERCE_ORDER = TYRION_URL + '/api/v1/ecommerce/order'

const ANALYTICS_API = TRUBEL_URL + '/api/v1/extract/event'
const USER_RESUME_TIMESTAMP = TRUBEL_URL + '/api/v1/load/resume-time'
const ADVERTISEMENT_ANALYTICS_API = TRUBEL_URL + '/api/v1/extract/advertisement-event'

export {
  ECOMMERCE_API,
  TEMPLATE_URL,
  WATCHLIST_URL,
  FAVOURITE_URL,
  CONTENT_SEARCH,
  LOGIN_API,
  SOCIAL_LOGIN_API,
  SIGNUP_API,
  LOGOUT_API,
  VALIDATE_SESSION,
  STATIC_PAGE,
  ACCOUNT_API,
  GET_ACTIVE_SUBSCRIPTIONS,
  GET_MY_PURCHASED_PLANS,
  GET_MY_ACCESSIBLE_PLANS,
  GET_SUBSCRIPTIONS,
  PAYEMENT_ORGS,
  GET_DISCOUNTS,
  GET_ESTIMATE,
  CREATE_TRANSACTION,
  CAPTURE_PAYMENT,
  GET_TRANSACTION,
  RELATED_CONTENT,
  DETAIL_CONTENT,
  GET_CATEGORY,
  CHANGE_PASSWORD,
  UPDATE_USER_INFO,
  VENUE_LISTING,
  ANALYTICS_API,
  ARTIST_LISTING,
  PARENT_DETAIL_CONTENT,
  CONTENT_WATCH_URL,
  GET_RENEWAL_SUBSCRIPTION,
  GET_REVIEWS_API,
  LIVE_COMMENTS_API,
  RESET_PASSWORD_KEY_VALIDATION,
  RESET_PASSWORD,
  SEND_VERIFY_EMAIL,
  VERIFY_EMAIL,
  FORGOT_PASSWORD,
  TEMPLATE_V2_URL,
  CONTENT_FILTERING,
  CUSTOM_PAGES_API,
  GET_COMMENTS_API,
  POST_LIKE_URL,
  IPTV_CHANNEL_FILTER,
  IPTV_CHANNEL_SCHEDULE,
  RELATED_CHANNEL,
  CUSTOM_FORM,
  AD_CAMPAIGN,
  AUDIO_WATCH_URL,
  INTERNAL_ASSET_API,
  SYSTEM_METADATA,
  GET_USER_TRANSACTION,
  USER_RESUME_TIMESTAMP,
  SEND_VERIFY_EMAIL_OTP,
  VERIFY_EMAIL_OTP,
  PLAYER_SESSION,
  ADVERTISEMENT_ANALYTICS_API,
  ECOMMERCE_ORDER,
  WISHLIST_URL,
  PRODUCT_FILTER_API,
  PRODUCT_FILTER_API_V2,
  IPTV_CHANNEL_EPG_SCHEDULE,
  POLL_API,
  OVERRIDE_FEED_API,
  LIVE_ADHOC_AD_API,
  IPTV_CHANNEL_PLAYLIST,
  IPTV_CHANNEL_CONTENT_URL,
}
